import { HttpInterceptorFn} from '@angular/common/http';
import { environment } from '../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  // const apiKey = environment.apiKey;

  // const modifiedReq = req.clone({
  //   headers: req.headers.set('api-key', apiKey),
  // });
  // return next(modifiedReq);

  const token = localStorage.getItem('token');
  //console.log(token);
  if (token) {
    req = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`),
    });
  }
  return next(req);
};


